import React, { useEffect, useRef } from 'react';

var SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;
var SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js';

function loadTurnstileScript() {
    return new Promise(function (resolve) {
        if (window.turnstile) { resolve(); return; }
        var existing = document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]');
        if (existing) {
            existing.addEventListener('load', resolve);
            if (window.turnstile) resolve();
            return;
        }
        var s = document.createElement('script');
        s.src = SCRIPT_SRC;
        s.async = true;
        s.onload = resolve;
        document.head.appendChild(s);
    });
}

export default function TurnstileWidget(props) {
    var onSuccess = props.onSuccess;
    var onError = props.onError;
    var onExpire = props.onExpire;

    var containerRef = useRef(null);
    var widgetIdRef = useRef(null);

    useEffect(function () {
        loadTurnstileScript().then(function () {
            setTimeout(function () {
                var el = containerRef.current;
                if (!el || !window.turnstile || widgetIdRef.current !== null) return;
                widgetIdRef.current = window.turnstile.render(el, {
                    sitekey: SITE_KEY,
                    theme: 'light',
                    size: 'normal',
                    callback: function (token) {
                        if (onSuccess) onSuccess(token);
                    },
                    'error-callback': function () {
                        if (onError) onError();
                    },
                    'expired-callback': function () {
                        if (onExpire) onExpire();
                    }
                });
            }, 300);
        });

        return function () {
            if (widgetIdRef.current !== null && window.turnstile) {
                try { window.turnstile.remove(widgetIdRef.current); } catch (e) {}
                widgetIdRef.current = null;
            }
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return React.createElement('div', { ref: containerRef });
}
